import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Home, ScanFace, User, MessageCircle, Send, X } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const CONTACTS = [
  {
    label: "Telegram-бот",
    note: "вопросы, код для входа, уведомления",
    href: "https://t.me/afanasievpro_bot",
    testid: "contacts-bot-link",
  },
  {
    label: "Личный Telegram",
    note: "вопросы, запись, консультации — @rudakov33",
    href: "https://t.me/rudakov33",
    testid: "contacts-channel-link",
  },
];

export const BottomNav = () => {
  const { pathname } = useLocation();
  const [contactsOpen, setContactsOpen] = useState(false);

  const tabs = [
    { to: "/", label: "Главная", icon: Home, testid: "bottom-nav-home" },
    { to: "/preview", label: "Приложение", icon: ScanFace, testid: "bottom-nav-app" },
    { to: "/account", label: "Кабинет", icon: User, testid: "bottom-nav-account" },
  ];

  return (
    <>
      <nav
        className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0A0A0A]/85 backdrop-blur-xl md:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="bottom-nav"
      >
        <div className="grid grid-cols-4">
          {tabs.map(({ to, label, icon: Icon, testid }) => {
            const active = pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className={`flex flex-col items-center gap-1.5 py-3 transition-colors duration-300 ${
                  active ? "text-[#C2A878]" : "text-[#525252]"
                }`}
                data-testid={testid}
              >
                <Icon size={18} strokeWidth={1.5} />
                <span className="font-jetbrains text-[8px] uppercase tracking-[0.2em]">{label}</span>
                <span
                  className={`h-px w-6 transition-colors duration-300 ${active ? "bg-[#C2A878]" : "bg-transparent"}`}
                />
              </Link>
            );
          })}
          <button
            onClick={() => setContactsOpen(true)}
            className="flex flex-col items-center gap-1.5 py-3 text-[#525252] transition-colors duration-300"
            data-testid="bottom-nav-contacts"
          >
            <MessageCircle size={18} strokeWidth={1.5} />
            <span className="font-jetbrains text-[8px] uppercase tracking-[0.2em]">Контакты</span>
            <span className="h-px w-6 bg-transparent" />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {contactsOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={() => setContactsOpen(false)}
              className="fixed inset-0 z-40 bg-[#0A0A0A]/70 backdrop-blur-sm"
              data-testid="contacts-backdrop"
            />
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ duration: 0.5, ease: EASE }}
              className="fixed inset-x-0 bottom-0 z-50 border-t border-[#C2A878]/20 bg-[#0F0F0F] px-6 pb-10 pt-5"
              data-testid="contacts-sheet"
            >
              <div className="mx-auto mb-6 h-px w-10 bg-white/20" />
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-jetbrains text-[10px] uppercase tracking-[0.35em] text-[#C2A878]">( Контакты )</p>
                  <p className="mt-3 font-cormorant text-3xl font-light text-[#F4F4F0]">
                    Мы на связи <span className="italic text-[#C2A878]">в Telegram</span>
                  </p>
                </div>
                <button
                  onClick={() => setContactsOpen(false)}
                  aria-label="Закрыть контакты"
                  className="mt-1 text-[#525252] transition-colors duration-300 hover:text-[#C2A878]"
                  data-testid="contacts-close"
                >
                  <X size={18} strokeWidth={1.5} />
                </button>
              </div>
              <div className="mt-7 border-t border-white/10">
                {CONTACTS.map((c) => (
                  <a
                    key={c.href}
                    href={c.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center gap-4 border-b border-white/10 py-4"
                    data-testid={c.testid}
                  >
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-white/10 text-[#C2A878] transition-colors duration-300 group-hover:border-[#C2A878]/60">
                      <Send size={15} strokeWidth={1.5} />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm text-[#F4F4F0]">{c.label}</span>
                      <span className="mt-0.5 block font-jetbrains text-[10px] uppercase tracking-[0.15em] text-[#525252]">
                        {c.note}
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};
